export type AppToastTone = 'info' | 'success' | 'error'

export interface AppToastPayload {
  message: string
  tone?: AppToastTone
}

export interface AppPromptOptions {
  title?: string
  message: string
  defaultValue?: string
  placeholder?: string
  inputType?: 'text' | 'number'
  confirmText?: string
  cancelText?: string
}

export interface AppConfirmOptions {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
}

export interface AppPromptEventPayload extends AppPromptOptions {
  resolve: (value: string | null) => void
}

export interface AppConfirmEventPayload extends AppConfirmOptions {
  resolve: (value: boolean) => void
}

export const APP_TOAST_EVENT = 'app:toast'
export const APP_PROMPT_EVENT = 'app:prompt'
export const APP_CONFIRM_EVENT = 'app:confirm'

export const showAppToast = (message: string, tone: AppToastTone = 'info'): void => {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(
    new CustomEvent<AppToastPayload>(APP_TOAST_EVENT, {
      detail: { message, tone },
    }),
  )
}

export const openAppPrompt = (options: AppPromptOptions): Promise<string | null> => {
  if (typeof window === 'undefined') {
    return Promise.resolve(null)
  }

  return new Promise((resolve) => {
    window.dispatchEvent(
      new CustomEvent<AppPromptEventPayload>(APP_PROMPT_EVENT, {
        detail: {
          ...options,
          resolve,
        },
      }),
    )
  })
}

export const openAppConfirm = (options: AppConfirmOptions): Promise<boolean> => {
  if (typeof window === 'undefined') {
    return Promise.resolve(false)
  }

  return new Promise((resolve) => {
    window.dispatchEvent(
      new CustomEvent<AppConfirmEventPayload>(APP_CONFIRM_EVENT, {
        detail: {
          ...options,
          resolve,
        },
      }),
    )
  })
}